module.exports = __webpack_public_path__ + "img/wicak.f5b1136b.jpg";